// extracted by mini-css-extract-plugin
module.exports = {"loader":"Logo_loader__1tJtu","logo":"Logo_logo__2VNNh"};